import { render, staticRenderFns } from "./mb-service-support.vue?vue&type=template&id=94e12c84&"
import script from "./mb-service-support.vue?vue&type=script&lang=js&"
export * from "./mb-service-support.vue?vue&type=script&lang=js&"
import style0 from "./mb-service-support.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports